module.exports = __webpack_public_path__ + "static/media/29COICT5.d40e6385.jpg";